import { WorkingHour } from 'interfaces/clinicSchedule';

export const checkIsRegularDayOff = (
  workingHour: string | WorkingHour[] | undefined
) => {
  if (Array.isArray(workingHour)) {
    const data = workingHour[0];

    if (!data?.start && !data?.end) {
      return true;
    }
  }

  return false;
};

export const checkIsPractitionerDayOff = ({
  isPractitionerClosed,
  practitionerWorkingHour,
}: any) => {
  if (isPractitionerClosed) return true;

  if (checkIsRegularDayOff(practitionerWorkingHour)) return true;

  return false;
};

export const checkIsClinicOff = ({
  isClinicClosed,
  isHoliday,
  clinicWorkingHour,
}: any) => {
  // holiday return isClosed: null
  if (isClinicClosed || isHoliday) return true;

  if (checkIsRegularDayOff(clinicWorkingHour)) return true;

  return false;
};
